import styled from 'styled-components';
import { DEAD_ZONE_SIZE, SIDEBAR_DEADZONE_Z_INDEX } from '../constants/SidebarConstants';
const CollapsableSidebarHeaderDeadZone = styled.div.withConfig({
  displayName: "CollapsableSidebarHeaderDeadZone",
  componentId: "sc-13x7v3l-0"
})(["block-size:100%;display:flex;justify-content:space-between;inline-size:100%;position:absolute;z-index:", ";width:100%;height:", "px;cursor:pointer;"], SIDEBAR_DEADZONE_Z_INDEX, DEAD_ZONE_SIZE);
export default CollapsableSidebarHeaderDeadZone;